
import { Options, mixins } from "vue-class-component";
import TabMenu from "primevue/tabmenu";
import router from "../router";
import { useStore, ActionTypes } from "../store";
import Toaster from "../helpers/Toaster";
import UtilityOptions from "../mixins/UtilityOptions";
import UserAuthentication from "../service/UserAuthentication";

@Options({
    components: {
        TabMenu,
    },
})
export default class Header extends mixins(UtilityOptions) {
    private showProgress = false;
    mounted() {
        // Focus the div to capture keys
        window.addEventListener("keypress", this.handleKeypress);
        localStorage.setItem("confirm_dialog", "0");
        localStorage.setItem("pos_items", "0");
        localStorage.setItem("pur_items", "0");
    }

    beforeUnmount() {
        // Remove event listener
        window.removeEventListener("keypress", this.handleKeypress);
    }

    handleKeypress(event) {
        // console.log('Key pressed:', event.key, 'KeyCode:', event.keyCode);

        if (event.keyCode === 43) {
            // Key "\"
            //  go to POS
            router.push({ path: "/pos" });
            return "";
        }
        if (event.keyCode === 124) {
            // Key "|" (shift + \)
            //  go to POS-Refund
            router.push({ path: "/pos-refund" });
            return "";
        }
        if (event.keyCode === 42) {
            // F12 example
            // console.log('F12 was pressed!');
        }
    }

    get menuItems() {
        const newList = this.items.filter((e) => {
            const p = this.can(e.permission);
            if ((e.permission != "" && p == true) || e.name == "More") return e;
        });

        newList.forEach((e) => {
            if (e.items != undefined) {
                e.items.forEach((i, j) => {
                    const p = this.can(i.permission);
                    if (
                        i.permission != "" &&
                        p == false &&
                        i.name != "Logout"
                    ) {
                        e.items.splice(j, 1);
                    }
                });
            }
        });

        return newList;
    }

    private items = [
        {
            label: "Dashboard",
            name: "Dashboard",
            permission: "dashboard",
            icon: "pi pi-fw pi-home",
            to: "/home/dashboard",
        },
        {
            label: "POS",
            name: "Orders",
            permission: "orders",
            icon: "pi pi-fw pi-shopping-cart",
            to: "/pos",
        },
        // {
        //   label: "Banking",
        //   name:"Banking",
        // permission: "dashboard",
        //   icon: "pi pi-fw pi-check-circle",
        //   to: "/store/banking"
        // },
        {
            label: "Purchases",
            name: "Purchasing",
            permission: "purchasing",
            icon: "pi pi-fw pi-table",
            to: "/purchasing",
        },
        {
            label: "Transactions",
            name: "Transaction Receipt",
            permission: "transaction_receipt",
            icon: "pi pi-fw pi-window-maximize",
            to: "/process/transactions",
        },
        {
            label: "More",
            name: "More",
            icon: "pi pi-fw pi-plus-circle",
            items: [
                {
                    label: "Cashier Sessions",
                    name: "Cashier Sessions",
                    permission: "view_cashier_session",
                    icon: "pi pi-fw pi-window-maximize",
                    to: "/cashier/cashier-session",
                },
                {
                    label: "Settings",
                    name: "Settings",
                    permission: "initialization",
                    icon: "pi pi-fw pi-cog",
                    to: "/store/initialization",
                },
                {
                    label: "Reports",
                    name: "Report",
                    permission: "report",
                    icon: "pi pi-fw pi-chart-bar",
                    to: "/report/index",
                },
                {
                    label: "Logout",
                    name: "Logout",
                    permission: "logout",
                    icon: "pi pi-fw pi-power-off",
                    command: () => this.logOut(),
                },
            ],
        },
    ];

    logOut() {
        const auth = new UserAuthentication();
        const store = useStore();
        this.showProgress = true;

        auth.logoutUser()
            .then((res) => {
                // console.log("LOGOUT RESPONSE ", res);

                const toast = new Toaster();

                const res2 = {
                    alert: "info",
                    msg: "Sign out successfully",
                };

                toast.handleResponse(res2);

                this.store.dispatch(ActionTypes.AUTH_LOGOUT, "");

                document.cookie =
                    "laravel_session=; Max-Age=0; path=/; domain=your-domain.com; secure;";
                document.cookie =
                    "XSRF-TOKEN=; Max-Age=0; path=/; domain=your-domain.com; secure;";

                router.push({ path: "/login" });
            })
            .catch((error) => {
                this.showProgress = false;
                console.error("Login error:", error);
            });
    }

    get progressBar() {
        return this.store.getters.getProgressBar;
    }
}
